import React from 'react';
import { Col, Row, Form } from 'reactstrap';
import { useTranslator, InputSelectControlled as Select } from '@front-activerse/common-components';

import HistoryChartPeriodSelect from '../../../Layout/Chart/HistoryChartPeriodSelect';

interface IMeasurementHistoryFiltersProps {
  measurementType: string;
  periodLength: number;
  handleMeasurementTypeChange: (value: string) => void;
  handlePeriodLengthChange: (value: number) => void;
  availableMeasurements: string[][];
}

const MeasurementHistoryFilters: React.FC<IMeasurementHistoryFiltersProps> = ({
  measurementType,
  periodLength,
  handleMeasurementTypeChange,
  handlePeriodLengthChange,
  availableMeasurements,
}) => {
  const { t } = useTranslator();

  return (
    <Row>
      <Col xs="12">
        <Form className="measurment-history-filters">
          <Row>
            <Col xs="6" sm="6" className="pe-1">
              <Select
                name="measurementType"
                handleChange={(event: React.FormEvent<HTMLInputElement>) =>
                  handleMeasurementTypeChange(event.currentTarget.value)
                }
                value={measurementType}
                small
              >
                {availableMeasurements.flat().map((type) => (
                  <option value={type} key={type}>
                    {t(`measurements.${type}`)}
                  </option>
                ))}
              </Select>
            </Col>
            <Col xs="6" sm="6" className="ps-1">
              <HistoryChartPeriodSelect
                value={periodLength}
                onChange={(event: React.FormEvent<HTMLInputElement>) =>
                  handlePeriodLengthChange(parseInt(event.currentTarget.value, 10))
                }
              />
            </Col>
          </Row>
        </Form>
      </Col>
    </Row>
  );
};

export default MeasurementHistoryFilters;
